const ADMIN_PERMISSIONS = {
  ACCOUNT_MANAGERS: 'account_managers',
  ACCESS_ALL_ACCOUNT: 'access_all_accounts',
  COUPONS: 'coupons',
  BUSINESS_TYPES: 'business_types',
  ACCOUNTS: 'accounts',
  ADD_ACCOUNT: 'add_account',
  EDIT_ACCOUNT: 'edit_account',
  CLONE_ACCOUNTS: 'clone_accounts',
  IMPERSONATE: 'impersonate',
  CHANGE_PACKAGE: 'change_package',
  CUSTOM_SOLUTIONS: 'custom_solutions',
  HELP: 'help',
  LOG_VIEWER: 'logviewer',
  NOTIFICATIONS: 'notifications',
  PAYMENT: 'payment',
  ANNOUNCEMENTS: 'announcements',
  PLANS: 'plans',
  STATISTICS: 'statistics',
  STICKERS: 'stickers',
  BUSINESS_CATEGORIES: 'business_categories',
  HORIZON: 'horizon',
  TELESCOPE: 'telescope',
  SUPER_ADMIN: 'super_admin',
  RECEIVE_REGULAR_REPORT: 'receive_regular_report',
  INVOICE_CRUDE: 'invoice_crud',
  INTEGRATIONS: 'integrations',
  URL_REDIRECT: 'urls',
}

export default ADMIN_PERMISSIONS
